import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const CloseIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 22 22">
      <circle cx="11" cy="11" r="11" fill="black" fillOpacity="0.08" />
      <path d="M14.2929 6.29289C14.6834 5.90237 15.3164 5.90237 15.707 6.29289C16.0973 6.68343 16.0974 7.31648 15.707 7.70696L12.414 10.9999L15.707 14.2929L15.7753 14.3691C16.0954 14.7618 16.073 15.3409 15.707 15.707C15.3409 16.073 14.7618 16.0954 14.3691 15.7753L14.2929 15.707L10.9999 12.414L7.70696 15.707C7.31648 16.0974 6.68343 16.0973 6.29289 15.707C5.90237 15.3164 5.90237 14.6834 6.29289 14.2929L9.58586 10.9999L6.29289 7.70696L6.22453 7.63078C5.90418 7.23801 5.92678 6.65901 6.29289 6.29289C6.65901 5.92678 7.23801 5.90418 7.63078 6.22453L7.70696 6.29289L10.9999 9.58586L14.2929 6.29289Z" fill="black" fillOpacity="0.4" />
    </SvgIcon>
  );
};

export default CloseIcon; 